module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//12.jpg?72e4b2df4d8f2aee8646b04c30dfe46f";